"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsUploadFileSettings = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsForm = require("../../components/DmsForm/DmsForm");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DmsUploadFileSettings = () => {
  const settings = [{
    label: _reactIntlUniversal.default.get("UploadDirectory").d("Upload Directory"),
    key: "upload_directory",
    value: '/tmp/',
    control: "folder",
    write: true
  }];
  return /*#__PURE__*/_react.default.createElement(_DmsForm.DmsForm, {
    url: "/file_settings",
    settings: settings
  });
};
exports.DmsUploadFileSettings = DmsUploadFileSettings;